var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"school-map loading-school-map",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":"https://image.noelshack.com/fichiers/2020/02/5/1578650202-spinner-1s-200px.gif","alt":"loading-animation"}})])
}]

export { render, staticRenderFns }